import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { FibaDropdown, Form, ListScreen, SERVER_HOST } from '../../components'
import { GridColumn } from '@progress/kendo-react-grid'
import { Field } from '@progress/kendo-react-form'
import { ORDER_DETAIL } from '../../constants/data.const'

const OrderDetail = () => {
    const { t } = useTranslation()
    const { id } = useParams()
    const [userSendData] = useState({ orderid: id })

    const colorCell = ({ dataItem }) => {
        return <td>
            <div className='rounded-full size-4'
                title={dataItem.color}
                style={{
                    backgroundColor: dataItem.color
                }}></div>
        </td>
    }

    const photoCell = ({ dataItem }) => {
        return <td>
            <div className='rounded-full size-16'>
                <img src={SERVER_HOST + dataItem.photo} alt="" />
            </div>
        </td>
    }

    return (
        <div>
            <Form
                read={'vo000003'}
                detail={'vo000004'}
                id={id}
            >
                <div className='my-4'>
                    <Field
                        name={'statusid'}
                        component={FibaDropdown}
                        label={"Төлөв"}
                        required={true}
                        data={ORDER_DETAIL}
                    />
                </div>
            </Form>
            <ListScreen
                read={'vo000002'}
                userSendData={userSendData}
                createable={false}
                deleteable={false}
                showDetail={false}
            >
                <GridColumn field='photo' title={t('photo')} cell={photoCell} />
                <GridColumn field='name' title={t('name')} filter='text' />
                <GridColumn field='color' title={t('color')} filter='text' cell={colorCell} />
                <GridColumn field='type' title={t('size')} filter='text' />
                <GridColumn field='price' title={t('price')} filter='text' />
                <GridColumn field='count' title={t('count')} filter='text' />
            </ListScreen>
        </div>
    )
}

export default OrderDetail